import React from 'react'
import store from 'store'
import { Provider } from 'react-redux'
import * as Containers from 'containers'

import { Router } from 'react-router-dom'
import { history } from 'utils'

import { MuiThemeProvider } from '@material-ui/core/styles'
import { baseTheme } from 'styles'

import MomentUtils from 'material-ui-pickers/utils/moment-utils'
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import ReactGA from 'react-ga'

import { IntlProvider } from 'react-intl';
import messages from 'constants/en.json'

if (process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID) {  
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID, {
    testMode: process.env.NODE_ENV === 'test'
  });
  history.listen(function (location) {
    ReactGA.pageview(location.pathname + location.search);
  });
}

export const AppContainer = () =>
  <Provider store={store}>
    <MuiThemeProvider theme={baseTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <IntlProvider locale="en-nz" defaultLocale="en-nz" messages={messages}>
          <Router history={history}>
            <Containers.App/>
          </Router>
        </IntlProvider>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  </Provider>

export default AppContainer